import { createServiceClient } from 'utils/apiClient'

const filesApi = createServiceClient('/files')

export default filesApi
